import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../redux/authSlice";
import { ImSpinner2 } from "react-icons/im";
import { FiCheck, FiEye, FiEyeOff, FiMail } from "react-icons/fi";
import logo from "../assets/logo.webp";
import GoogleLoginButton from "../components/GoogleLoginButton";
import styles from "../styles/login.module.css";

const Login = () => {
  const user = useSelector((state) => state.auth.user);
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [emailFocus, setEmailFocus]   = useState(false);
  const [passFocus, setPassFocus]     = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      setLoading(true);
      navigate(user.isAdmin ? "/admin" : "/");
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      setLoginLoading(true);
      const result = await dispatch(login({ email, password })).unwrap();
      navigate(result.user?.isAdmin ? "/admin" : "/");
    } catch (err) {
      setError(err?.message || "فشل تسجيل الدخول. تحقق من بياناتك وحاول مجدداً.");
    } finally {
      setLoginLoading(false);
    }
  };

  if (loading) return null;

  return (
    <div className={styles.page}>
      <div className={styles.card}>

        {/* Logo */}
        <img src={logo} alt="فزاكر" className={styles.logo} />

        {/* Heading */}
        <h2 className={styles.heading}>تسجيل الدخول</h2>
        <p className={styles.subheading}>أهلاً بك مجدداً، سجّل دخولك للمتابعة</p>

        {/* Form */}
        <form className={styles.form} onSubmit={handleLogin}>

          {/* Email */}
          <div className={styles.fieldWrap}>
            <label className={`${styles.floatLabel} ${emailFocus || email ? styles.floatLabelUp : ''}`}>
              البريد الإلكترونى
            </label>
            <input
              type="email"
              maxLength={100}
              value={email}
              onChange={e => setEmail(e.target.value)}
              onFocus={() => setEmailFocus(true)}
              onBlur={() => setEmailFocus(false)}
              autoComplete="email"
              required
              className={styles.input}
            />
            <FiMail className={styles.fieldIcon} />
          </div>

          {/* Password */}
          <div className={styles.fieldWrap}>
            <label className={`${styles.floatLabel} ${passFocus || password ? styles.floatLabelUp : ''}`}>
              كلمة المرور
            </label>
            <input
              type={showPass ? "text" : "password"}
              maxLength={20}
              value={password}
              onChange={e => setPassword(e.target.value)}
              onFocus={() => setPassFocus(true)}
              onBlur={() => setPassFocus(false)}
              autoComplete="current-password"
              required
              className={styles.input}
            />
            <button
              type="button"
              className={styles.eyeBtn}
              onClick={() => setShowPass(s => !s)}
              tabIndex={-1}
            >
              {showPass ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>

          {/* Error */}
          {error && <p className={styles.error}>{error}</p>}

          {/* Submit */}
          <button type="submit" disabled={loginLoading} className={styles.submitBtn}>
            {loginLoading
              ? <ImSpinner2 className={styles.spinner} />
              : <FiCheck />
            }
            تسجيل الدخول
          </button>
        </form>

        {process.env.REACT_APP_GOOGLE_CLIENT_ID && (
          <>
            <div className={styles.orDivider}><span>أو</span></div>
            <GoogleLoginButton onError={setError} />
          </>
        )}

        <div className={styles.divider} />

        {/* Footer links */}
        <div className={styles.links}>
          <div className={styles.linkRow}>
            <span>هل نسيت كلمة المرور؟</span>
            <Link to="/forgotpass" className={styles.link}>اضغط هنا</Link>
          </div>
          <div className={styles.linkRow}>
            <span>لا يوجد حساب لديك؟</span>
            <Link to="/signup" className={styles.link}>أنشىء حساب</Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Login;
